export class GetAllPortalDraws {
  static readonly type = '[PortalDraw] Get All Draws';
}

export class GetActivatedPortalDraws {
  static readonly type = '[PortalDraw] Get Activated Draws';
}

export class InitializePortalDraw {
  static readonly type = '[PortalDraw] Initialize Draw';
  constructor(public payload: { examId: string; quantityOfApplications: number }) {}
}

export class InitializeManualPortalDraw {
  static readonly type = '[PortalDraw] Initialize Manual Draw';
  constructor(public payload: { examId: string; applicationIds: string[] }) {}
}

export class UpdatePortalDraw {
  static readonly type = '[PortalDraw] Update Draw';
  constructor(public payload: { id: string; examId: string; quantityOfApplications: number }) {}
}

export class GetSinglePortalDrawByExamId {
  static readonly type = '[PortalDraw] Get Single Draw By Exam Id';
  constructor(public payload: string) {}
}

export class GetSinglePortalDrawById {
  static readonly type = '[PortalDraw] Get Single Draw By Id';
  constructor(public payload: string) {}
}

export class DeletePortalDrawById {
  static readonly type = '[PortalDraw] Delete Draw By Id';
  constructor(public payload: string) {}
}

export class SetSelectedDraw {
  static readonly type = '[PortalDraw] Set Selected Draw';
  constructor(public payload: any) {}
}
